module.exports = __webpack_public_path__ + "media/images/salesreportbg-0d5da75e9d11e3ad58bfca85dc9a92b1.png";